import React, { Fragment } from 'react';
import { api } from '../api';
import { Button, Form } from 'react-bootstrap';

class VendorCreator extends React.Component {
    constructor() {
        super();

        this.state = {
            name: "",
            description: "",
            latitude: 0,
            longitude: 0,
            city: "",
            territory: ""
        };
    }

    async createVendor(event) {
        event.preventDefault();
        const created = await api.createVendor({
            name: this.state.name,
            description: this.state.description,
            latitude: parseFloat(this.state.latitude) || null,
            longitude: parseFloat(this.state.longitude) || null,
            city: this.state.city,
            territory: this.state.territory,
        });
        this.setState({ vendorId: created.id });
    }

    async updateStateValue(event, stateKey) {
        event.preventDefault();
        this.setState({ [stateKey]: event.target.value });
    }

    render() {
        return (
            <Fragment>
                <div style={{ padding: "24px 12px 24px 12px", marginTop: "100px", marginBottom: "100px" }}>
                    <h1>Create Vendor</h1>
                    <Form
                        noValidate
                        onSubmit={e => this.createVendor(e)}
                        style={{ width: "353px" }} >
                        <Form.Group>
                            <Form.Control style={{ width: "353px", marginBottom: "12px" }} type="text" placeholder="Shop Name" onChange={e => this.updateStateValue(e, "name")}/>
                            <Form.Control style={{ width: "353px", marginBottom: "12px" }} type="text" placeholder="Shop Description" onChange={e => this.updateStateValue(e, "description")}/>
                            <Form.Control style={{ width: "353px", marginBottom: "12px" }} type="text" placeholder="City (ex: Seattle)" onChange={e => this.updateStateValue(e, "city")}/>
                            <Form.Control style={{ width: "353px", marginBottom: "12px" }} type="text" placeholder="State (ex: Washington)" onChange={e => this.updateStateValue(e, "territory")}/>
                            <Form.Control style={{ width: "353px", marginBottom: "12px" }} type="text" placeholder="Latitude" onChange={e => this.updateStateValue(e, "latitude")}/>
                            <Form.Control style={{ width: "353px", marginBottom: "12px" }} type="text" placeholder="Longitude" onChange={e => this.updateStateValue(e, "longitude")}/>
                            <Button variant="primary" type="submit" style={{ float: "right"}}>
                                Create
                            </Button>
                        </Form.Group>
                    </Form>
                </div>
            </Fragment>
        );
    }
}

export { VendorCreator };
